import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function WhyOldSolutionsFail() {
  return <section className="py-20 px-6 bg-[#F2EFE9]" data-id="element-245">
      <div className="max-w-2xl mx-auto" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-4 text-charcoal" data-id="element-248">
            Why old solutions fail
          </h2>
          <p className="text-center text-charcoal/60 mb-12 text-lg" data-id="element-249">
            You've tried. It's not a you problem.
          </p>

          <div className="space-y-5" data-id="element-250">
            {[{
            solution: '"Self-care"',
            reason: "doesn't remove interruptions."
          }, {
            solution: '"Time management"',
            reason: "doesn't solve transitions."
          }, {
            solution: 'Complex routines',
            reason: 'create more decisions (then you quit).'
          }, {
            solution: 'Cleaning systems',
            reason: 'ignore the emotional trigger windows (re-entry + bedtime).'
          }].map((item, i) => <div key={i} className="flex items-start gap-4 p-5 bg-white/70 rounded-lg border border-charcoal/5" data-id="element-251">
                <div className="w-8 h-8 rounded-full bg-terracotta/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-252">
                  <X className="w-4 h-4 text-terracotta" data-id="element-253" />
                </div>
                <p className="text-lg text-charcoal leading-relaxed" data-id="element-254">
                  <strong className="text-charcoal" data-id="element-255">{item.solution}</strong>{' '}
                  <span className="text-charcoal/70" data-id="element-256">{item.reason}</span>
                </p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}